"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostStartRecrutationUrl = "/StartRecrutation";
//# sourceMappingURL=PostStartRecrutation.js.map